import React from 'react';
import { Reveal } from './ui/Reveal';
import { routeSteps } from '../data/content';
export function NotJustInfoSection() {
  return <section aria-labelledby="ruta-bases" className="border-y-2 border-blush bg-blush-soft" data-id="element-124" data-mp="z04o5lkqcfez">
      <div className="mx-auto max-w-page px-3 py-6 text-center sm:px-6 sm:py-8" data-id="element-125" data-mp="1dosi5nexgh2t">
        <Reveal data-id="element-126" data-mp="18vzel2v73esb">
          <h2 id="ruta-bases" className="mx-auto max-w-3xl font-display text-lg font-black uppercase leading-[1.08] text-ink sm:text-2xl lg:text-3xl" data-id="element-127" data-mp="18vg58ajm1ypw">
            Esto no es solo información sobre coreano
          </h2>
          <p className="mt-0.5 font-display text-sm font-black uppercase text-coral sm:text-lg" data-id="element-128" data-mp="1wmljil9wkiy3">
            Es una ruta para construir tus bases.
          </p>
        </Reveal>

        <ul className="mx-auto mt-3 grid max-w-4xl gap-1.5 text-left sm:grid-cols-2 lg:grid-cols-3" data-id="element-129" data-mp="2812ciksj5jg">
          {routeSteps.map((step, i) => <Reveal key={step.text} as="li" delay={i * 0.03} className="flex items-center gap-2 rounded-lg border border-blush bg-white px-2.5 py-2 font-body text-[0.78rem] font-semibold text-ink sm:text-[0.82rem]" data-id="element-130" data-mp="3tfx1uff8k9dx" data-mpi={i}>
              <span aria-hidden="true" className="text-base" data-id="element-131" data-mp="2j46wz14gbazl">
                {step.icon}
              </span>
              {step.text}
            </Reveal>)}
        </ul>

        <Reveal delay={0.08} className="mx-auto mt-4 max-w-2xl" data-id="element-132" data-mp="2svkux4gr82qm">
          <p className="font-body text-[0.8rem] leading-snug text-slate sm:text-sm" data-id="element-133" data-mp="2sxdygaw2m6ue">
            Tu objetivo no es terminar el último tomo y decir “lo leí”.
          </p>
          <p className="mt-1 font-body text-[0.8rem] leading-snug text-ink sm:text-sm" data-id="element-134" data-mp="31w967rerjozt">
            <span className="font-bold" data-id="element-135" data-mp="36tj7c4bilp3h">Tu objetivo</span> es poder mirar
            Hangul, reconocer elementos que antes parecían desconocidos,
            comprender palabras y frases básicas y explicar con tus propias
            palabras la lógica que estás aprendiendo.
          </p>
        </Reveal>
      </div>
    </section>;
}